import { render, staticRenderFns } from "./ViewAllPersonOrgModal.vue?vue&type=template&id=426b51b9&scoped=true&"
import script from "./ViewAllPersonOrgModal.vue?vue&type=script&lang=js&"
export * from "./ViewAllPersonOrgModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllPersonOrgModal.vue?vue&type=style&index=0&id=426b51b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b51b9",
  null
  
)

export default component.exports